export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">개인정보처리방침</h1>
        <p className="text-stone-500 mb-8">최종 수정일: 2026년 5월 18일</p>
        <div className="bg-white rounded-xl border border-stone-200 p-6 space-y-6 text-sm text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제1조 (수집하는 개인정보)</h2>
            <p>회사는 서비스 제공을 위해 다음 개인정보를 수집합니다:</p>
            <p className="mt-2"><strong>필수 항목:</strong> 이메일, 비밀번호, 닉네임, 성별, 출생년도, 거주지역</p>
            <p><strong>선택 항목(정회원 이상):</strong> 이름, 전화번호, 카카오톡 ID, 직업, 학력, 종교, MBTI, 키, 체형, 흡연·음주 여부, 자녀 유무, 프로필 사진, 자기소개, 그리고 <strong>결혼이력(미혼·기혼·이혼·사별·재혼)</strong></p>
            <p><strong>서류 인증:</strong> 혼인관계증명서 등 본인 확인 서류 (심사 완료 후 원본 즉시 삭제, 인증 결과만 보관)</p>
            <p><strong>결제 정보:</strong> Stripe를 통해 처리되며, 회사는 카드 정보를 직접 저장하지 않습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제2조 (개인정보의 이용 목적)</h2>
            <p>1. 회원 가입 및 본인 확인, 불량 회원 부정 이용 방지</p>
            <p>2. AI 분석을 포함한 매칭 서비스 제공</p>
            <p>3. <strong>재혼·이혼·사별 회원을 위한 전용 매칭 및 콘텐츠 추천</strong></p>
            <p>4. 이벤트 안내 및 마케팅 (별도 동의한 회원에 한함)</p>
            <p>5. 서비스 이용 통계 및 개선</p>
            <p>6. 회원 간 상호 이해를 돕기 위한 프로필 정보 노출 (회원의 공개 동의 시)</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제3조 (개인정보의 보관 기간)</h2>
            <p>1. 회원 탈퇴 시 30일 이내 삭제 (법적 보관 의무가 있는 정보 제외)</p>
            <p>2. 결제 기록: 5년 (전자상거래법)</p>
            <p>3. 로그인 기록: 3개월</p>
            <p>4. 혼인관계증명서 등 본인 확인 서류: 심사 완료 즉시 원본 삭제, 인증 결과만 보관</p>
            <p>5. 가입 동의 기록(약관/개인정보/결제·환불/만 19세 확인): 회원 탈퇴 후에도 분쟁 대응을 위해 5년간 보관 후 파기</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제4조 (민감 정보 및 결혼이력 처리)</h2>
            <p>1. <strong>이혼·사별·재혼 관련 결혼이력</strong>은 회원이 자발적으로 입력하는 선택 항목이며, 동의 시에만 수집·이용됩니다.</p>
            <p>2. 해당 정보는 매칭 적합도 산정 및 회원 간 상호 이해를 돕기 위해서만 사용되며, 별도의 동의 없이 제3자에게 제공되지 않습니다.</p>
            <p>3. 회원은 언제든 마이페이지에서 결혼이력 정보를 수정하거나 삭제할 수 있습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제5조 (프로필 공개 처리)</h2>
            <p>1. 회사는 회원 가입 시 <strong>"내 프로필을 회원정보보기에 공개"</strong> 선택 동의를 받습니다.</p>
            <p>2. 공개 동의 회원의 프로필(닉네임, 프로필 사진, 자기소개, 성별, 출생년도, 거주지역 등)은 다른 회원이 "회원정보보기" 목록에서 열람할 수 있습니다.</p>
            <p>3. 동의하지 않은 회원의 프로필은 회원정보보기 목록에서 자동 비공개 처리되며, 매칭 추천 등 회사가 명시적으로 안내한 기능에 한해서만 노출됩니다.</p>
            <p>4. 회원은 마이페이지의 노출 ON/OFF 스위치로 언제든 공개 여부를 변경할 수 있습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제6조 (개인정보의 보호 조치)</h2>
            <p>1. 비밀번호는 bcrypt 해시 알고리즘으로 암호화 저장됩니다.</p>
            <p>2. 민감 서류(혼인관계증명서)는 AES-256(Fernet) 암호화로 저장됩니다.</p>
            <p>3. 업로드 파일은 Emergent Object Storage에 영구 저장되며, 모든 데이터 전송은 SSL/TLS로 보호됩니다.</p>
            <p>4. 파일명은 난수화하여 원본 파일명이 노출되지 않습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제7조 (제3자 제공)</h2>
            <p>회사는 회원의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우 예외로 합니다:</p>
            <p>1. 회원이 사전에 동의한 경우</p>
            <p>2. 법률에 의해 요구되는 경우</p>
            <p>3. 결제 처리를 위해 Stripe에 필요 최소 정보를 전달하는 경우</p>
            <p>4. 이메일 발송을 위해 Resend에 수신자 이메일 주소를 전달하는 경우</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제8조 (회원의 권리)</h2>
            <p>1. 개인정보 열람·수정·삭제 요청 권리</p>
            <p>2. 마케팅 수신 동의 철회 권리</p>
            <p>3. 프로필 공개 동의 철회 권리(언제든 비공개 전환 가능)</p>
            <p>4. 결혼이력 등 선택 정보의 입력 거부 권리</p>
            <p>5. 회원 탈퇴 및 개인정보 삭제 요청 권리</p>
            <p className="mt-2">위 요청은 고객센터(contact@newcoupling.com)로 연락해 주세요.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제9조 (개인정보 보호 책임자)</h2>
            <p>성명: New Coupling 운영팀</p>
            <p>이메일: contact@newcoupling.com</p>
            <p>전화: 1-647-292-3959 (캐나다) / 010-9474-3959 (서울)</p>
          </section>
        </div>
      </div>
    </div>
  );
}
